import { LinuxIcon } from './LinuxIcon';

/**
 * author: Contributors
 * id A58FE3A3-BC2C-48A4-8146-0D15F1B80128
 * name linux
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/linux.svg
 * tags
 * - Animal 
 * - Brand / Logo 
 */
export const TuxIcon = LinuxIcon;
export default TuxIcon